import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import referralWelcomeForInvitee from '@/assets/images/referral/first_register.png';
import infoIcon from '@/assets/images/referral/infoicon.png';

function ReferralWelcomeForInvitee(): ReactElement {
    const { t } = useTranslation('referral');

    return (
        <div className="text-gray-800">
            <h3 className="text-2xl font-semibold mb-4 tracking-widest text-center">
                {t('welcome.title')}
            </h3>
            <img
                src={referralWelcomeForInvitee}
                alt={t('welcome.imageAltMain')}
                className="lg:w-2/3 mx-auto rounded-xl my-8"
            />
            <p className="mb-6 leading-8 tracking-widest">
                {t('welcome.body1')}
            </p>
            <p className="mb-6 leading-8 tracking-widest">
                {t('welcome.body2')}
            </p>
            <img
                src={infoIcon}
                alt={t('welcome.imageAltInfo')}
                className="mx-auto rounded-xl my-8"
            />
            <p className="mb-6 leading-8 tracking-widest">{t('welcome.body3')}</p>
        </div>
    );
}

export default ReferralWelcomeForInvitee;
